module.exports = fox._r("images/easter18/gift-71.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/easter18/gift-71.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/easter18/gift-71.png
// module id = 295
// module chunks = 4